import api from 'src/services/api';
import * as utils from './apiUtils';
import {
  type DeviceIndexResponse,
  type DeviceResponse,
  toDevice,
} from 'src/models/apis/device/deviceResponse';
import type { Device } from 'src/models/device';
import {
  type AdminDeviceIndexResponse,
  toAdminDevice,
} from 'src/models/apis/device/adminDeviceResponse';
import type { AdminDevice } from 'src/models/device';
import type { AdminDeviceParams } from 'src/models/apis/device/adminDeviceRequest';

export default {
  async index(): Promise<Device[]> {
    const response = await api.get<DeviceIndexResponse>(utils.getApiUrl('/devices'));
    return response.data.map(toDevice);
  },
  async adminIndex(): Promise<AdminDevice[]> {
    const response = await api.get<AdminDeviceIndexResponse>(utils.getApiUrl('/admin/devices'));
    return response.data.map(toAdminDevice);
  },
  async adminCreate(params: AdminDeviceParams): Promise<AdminDevice> {
    const response = await api.post<DeviceResponse>(utils.getApiUrl('/admin/devices'), params);
    return toAdminDevice(response.data);
  },
  async adminUpdate(deviceId: string, params: AdminDeviceParams): Promise<AdminDevice> {
    const response = await api.put<DeviceResponse>(utils.getApiUrl(`/admin/devices/${deviceId}`), params);
    return toAdminDevice(response.data);
  },
  async adminDestroy(devideId: string): Promise<AdminDevice> {
    const response = await api.delete<DeviceResponse>(utils.getApiUrl(`/admin/devices/${devideId}`));
    return toAdminDevice(response.data);
  },
};
